export default __webpack_public_path__ + "static/howWeWork2-7c7e9fb79571106755d6fa4af6553dc6.png";